'use strict'

Vue.component('awe-product-search', {
  props:{
    wtbid: {type: String},
    country:{type: String},
    locale: {type: String, default: 'en'},
    showResults: {type: Boolean, default: true},
  },

  data: function(){
    return {
      i18n: window.i18n,
      searchBarFocused: false,
      searchedText: '',
      timeout: '',
      searchResults: [],
      loading: false,
      noResultFound: false,
      showNoResultsMessaging: false,
      searchResultsOpen: false,
      showLoader: false,
      initialScope: []
    }
  },
  created: function() {
    this.initialScope = this.$root.eans
    this.$root.$on('scope-update', evt => {
      this.initialScope = evt.eans
    })
  },
  watch:{
    searchedText: {
      handler: function(value) {
        // if we are not showing the results in the dropdown, do not open the dropdown
        if (!this.showResults)
          return;

        // clear everything if there is no value in the search bar
        if (!value) {
          this.searchResults = [];
          this.loading = false;
          this.searchResultsOpen = true;
          this.showLoader = false;
        } else {
          this.showNoResultsMessaging = false;
        }
      }
    },
    loading: {
      handler: function (value) {
        if (value) {
          this.showLoader = true;
          app.showLoader('product-search', 0)

          // do not open the search results dropdown if we are not showing results there
          if (!this.showResults)
            return;

          // search results are populated and the search object is on the dom
          // add search-results-open class to parent
          this.searchResultsOpen = true;
        } else if (this.noResultFound) {
          app.hideLoader('product-search', 0);

          setTimeout(()=>{ this.showNoResultsMessaging = true }, 450)

        } else {
          // hiding loader container
          this.showLoader = false;
          // hiding the actual loader component
          app.hideLoader('product-search', 0)
          // no search results
          this.searchResultsOpen = false;
        }
      }
    },
    searchResults: {
      handler: function(){
        // if we are not showing the results in the dropdown, do not open the dropdown
        if (!this.showResults)
          return;

        if (this.searchedText) {
          // search results are populated and the search object is on the dom
          // add search-results-open class to parent
          this.searchResultsOpen = true;
        } else {
          // no search results
          this.searchResultsOpen = false;
        }
      }
    },
    searchBarFocused: {
      handler: function() {
        // if we are not showing the results in the dropdown, do not open the dropdown
        if (!this.showResults)
          return;

        // results list disappears when a user clicks out
        if (!this.searchBarFocused && this.searchResultsOpen) {
          this.searchResultsOpen = false;
        }

        // results list reappears when a user focuses back in on the search bar
        if (this.searchBarFocused && this.searchResults.length) {
          this.searchResultsOpen = true;
        }

        if (!this.searchBarFocused && this.noResultFound) {
          this.showLoader = false;
        }

        if (this.searchBarFocused && this.noResultFound) {
          this.showLoader = true;
          this.searchResultsOpen = true;
        }
      }
    }
  },
  methods:{
    toggleFocusState: function(event) {
      // this logic forces the search results to stay open when a user is tabbing through the list
      if (event?.type === 'blur' && event?.relatedTarget?.classList.contains('search-results') && !this.productSelected) {
        this.searchBarFocused = true;
        return;
      }

      this.searchBarFocused = !this.searchBarFocused;

      // if productSelected is true, a user selected a product in the search results
      // we need to hide the search results then set productSelected back to false
      this.productSelected = false;
    },
    searchTimeOut: function() {
      // debounce queries to product api
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.executeSearch, 250);
    },
    executeSearch: async function() {
      if (this.searchedText.length === 0)
        return this.clearSearch()

      if (this.searchedText.length < 3) {
        return;
      }
      this.searchResults = [];
      // if the user deleted the search term completely
      // return early and set the searchResults to an empty array
      if (!this.searchedText){
        return;
      }

      this.loading = true;

      try {
        let qs = `?wtbid=${this.wtbid}&q=${encodeURIComponent(this.searchedText)}&lang=${this.locale}&country=${this.country}`;

        const res = await fetch('https://wtb-api-hub.swaven.com/wtb/v2/api/search/products' + qs, {credentials: 'include'});

        if (res.status === 400) {
          // no string matched the query
          this.noResultFound = true;
          return;
        } else if (res.status !== 200){
          throw new Error('Request error');
        }

        const data = await res.json();

        this.noResultFound = false;
        // if showResults is true, render the returned products in a list below the search bar
        if (this.showResults) {
          this.searchResults = data.products;
        } else {
          // if showResults is false, compile an array of eans from the response, and emit to the parent component
          const eans = data.products.map(p => p.ean)
          this.$emit('eans-update', {
            eans,
          });
        }

      } catch (ex) {
        Tracker.log('error', {msg: ex.message, stack: ex.stack})
      } finally {
        this.loading = false;
      }
    },
    clearSearch: function() {
      this.searchedText = '';
      this.searchResults = [];
      this.noResultFound = false;
      this.showNoResultsMessaging = false;

      if (this.initialScope?.length)
        this.$emit('eans-update', { eans: this.initialScope })
    },
    productSelection: function(event, index) {
      const product = this.searchResults[index];
      const formattedProduct = this.formatProductSelection(product);
      this.$emit('product-select', formattedProduct);
      this.$emit('change', formattedProduct, index);
      this.$emit('reset-filters', formattedProduct.ean);
      this.productSelected = true;

      if (event.key) {
        this.toggleFocusState();
      }
    },
    formatProductSelection: function(selectedProduct) {
      return Mapping.mapProducts([selectedProduct])[0];
    },
    getAriaLabelForSearchResult: function(product) {
      return `${product?.pname}`;
    },
    allowProductSearchNavigation: function(e) {
      e.preventDefault();
      if (this.searchResults) {
        this.searchBarFocused = true;
        document.getElementById('search-result-list').firstChild.focus();
      }
    },
  },
  template: `
  <div class="product-search">
    <span class="inline-loader" >
      <awe-loader type="product-search" ></awe-loader>
    </span>
    <span v-if="noResultFound" class='search-no-result-overlay'></span>
    <form class="input-container" id="input-container" role="search" v-on:submit="(e)=>{ e.preventDefault() }" :class="{searchOverlay: noResultFound}">
      <div class="search" :class="{'search-results-open': searchResultsOpen || noResultFound, focus: searchBarFocused}">
        <i class="icon-search"></i>
        <input
        v-model="searchedText"
        autocomplete="off"
        class="product-search-bar"
        id="search-bar"
        type="text"
        :placeholder="i18n.getString('SEARCH_PLACEHOLDER')"
        aria-label="Search"
        v-on:input="searchTimeOut"
        v-on:focus="toggleFocusState"
        v-on:blur="toggleFocusState"
        v-on:keydown.tab="allowProductSearchNavigation"
        >
        <span class="clear-icon-container" id="clear-container">
          <div class="clear" v-show="searchedText || searchBarFocused" v-on:click="clearSearch">
            {{i18n.getString('CLEAR')}}
            <i id="clear-icon" class="icon-cancel"></i>
          </div>
        </span>
        <div v-show="noResultFound" id="product-search-loader" class="search-result-container">
          <div class="no-results-message" v-if="showNoResultsMessaging">
            {{i18n.getString('SEARCH_PRODUCT_NO_RESULT')}}
          </div>
        </div>
        <ol class="search-result-container" id="search-result-list" aria-label="product-search-results" v-show="searchResults.length && searchBarFocused && showResults">
          <li
            class="search-results"
            role="listitem"
            v-for="(product, index) in searchResults"
            :aria-label="getAriaLabelForSearchResult(product)"
            :tabindex="0"
            v-on:mousedown="productSelection($event, index)"
            v-on:keydown.enter="productSelection($event, index)"
          >
            <div class="img-container">
              <img loading="lazy" class="product-logo"
                :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.pimgurl) + '?width=200&org_if_sml=1&ci_url_encoded=1'"
                :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(product.pimgurl) + '?width=200&org_if_sml=1&ci_url_encoded=1 1x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(product.pimgurl) + '?width=300&org_if_sml=1&ci_url_encoded=1 1.5x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(product.pimgurl) + '?width=400&org_if_sml=1&ci_url_encoded=1 2x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(product.pimgurl) + '?width=600&org_if_sml=1&ci_url_encoded=1 3x'"
                :title="product.pname" :alt="product.pname">
            </div>
            <div class="product-name" :key="index">
              {{product.pname}}
            </div>
          </li>
        </ol>
      </div>
    </form>
  </div>
  `
})



